import React from "react"
import { Link } from "@zestia/gatsby-plugin-react-i18next"
import { GatsbyImage } from "gatsby-plugin-image"
import { useTranslation } from "react-i18next"
const StackingContentBlock = ({
  index,
  kicker,
  title,
  description,
  image,
  link,
}) => {
  const { t } = useTranslation()
  return (
    <div className="stacking__content-block" key={index}>
      <div className="p-8 md:p-16 stacking__content-block__content">
        <div>
          <h2 className="stacking__content-block__kicker mb-0 p">{kicker}</h2>

          <h3 className="mb-0">{title}</h3>

          <p className="mb-0 mt-6 p--lg">{description}</p>
        </div>

        <Link
          to={link.url}
          className="btn btn--dark btn--lg mt-4 md:mt-8"
          aria-label={`${t("common.learn-more")} - ${kicker}`}
        >
          {t("common.learn-more")}
        </Link>
      </div>

      <div className="stacking__content-block__image">
        <GatsbyImage
          image={image}
          alt={title}
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "8px",
            objectFit: "cover",
          }}
        />
      </div>
    </div>
  )
}

export default StackingContentBlock
